import { Box } from '@nimbus-ds/components';
import { Country } from '@tiendanube/common/src/enums';
import FeatureFlag from 'App/components/FeatureFlag';
import { PROJECT_SHIVA_TAG } from 'App/featuresFlags';
import HelpLink from 'App/HelpLink';
import {
  DASHBOARD_CAN_LINKS,
  DASHBOARD_POS_CAN_LINKS,
} from 'commons/constants';
import { useTranslationLanguage } from 'commons/hooks';
import { useGetCountry } from 'domains/Auth/hooks';
import { useTranslationDashboard } from 'domains/Dashboard/hooks';
import { MIGRATE_LINKS } from '../../constants';
import MercadoShops from '../MercadoShops';

interface DashboardHelpLinkProps {
  isPos: boolean;
  hasOnboardingIncomplete: boolean;
}

export function DashboardHelpLink({
  isPos,
  hasOnboardingIncomplete,
}: Readonly<DashboardHelpLinkProps>) {
  const t = useTranslationDashboard();
  const language = useTranslationLanguage();
  const storeCountry = useGetCountry();
  const countryLink = MIGRATE_LINKS[storeCountry] ?? MIGRATE_LINKS[Country.AR];

  if (isPos && hasOnboardingIncomplete) {
    return (
      <HelpLink
        title={t('posCanLink')}
        linkURL={DASHBOARD_POS_CAN_LINKS[language]}
        icon="both"
        previousValue=""
        currentViewTracking=""
      />
    );
  }

  if (!hasOnboardingIncomplete) {
    return (
      <HelpLink
        title={t('canLink')}
        linkURL={DASHBOARD_CAN_LINKS[language]}
        icon="both"
        previousValue="dashboard"
        currentViewTracking="help"
      />
    );
  }

  if (!isPos && hasOnboardingIncomplete) {
    return (
      <FeatureFlag
        flag={PROJECT_SHIVA_TAG}
        renderElse={
          <Box>
            <HelpLink
              title={t('onboardingLink.externalLink.label')}
              linkURL={t('onboardingLink.externalLink.href')}
              icon="both"
              previousValue="dashboard"
              currentViewTracking="primeros-pasos"
            />
          </Box>
        }
      >
        <Box>
          <MercadoShops />
          <HelpLink
            title={t('shivaProject.migration')}
            linkURL={countryLink}
            icon="both"
            previousValue="dashboard"
            currentViewTracking="primeros-pasos"
            showInMobile
          />
        </Box>
      </FeatureFlag>
    );
  }

  return (
    <HelpLink
      title={t('canLink')}
      linkURL={DASHBOARD_CAN_LINKS[language]}
      icon="both"
      previousValue="dashboard"
      currentViewTracking="help"
    />
  );
}
